import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHighlighter32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconHighlighter32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m21.864 7.01 4.325 4.325-8.991 10.608L11.256 16zM10.197 17.77 8.93 21.141l3.127 3.128 3.372-1.267zM20.57 5.484a2 2 0 0 1 2.707.112l4.325 4.325a2 2 0 0 1 .111 2.707l-9.48 11.187a2 2 0 0 1-.823.579l-5.254 1.973a1 1 0 0 1-.861-.076l-1.332 1.225a2 2 0 0 1-1.354.528H7.214c-2.249 0-3.354-2.737-1.736-4.299L7.12 22.16l-.06-.06a1 1 0 0 1-.229-1.059l1.974-5.253a2 2 0 0 1 .579-.823zM8.535 23.574l1.322 1.323-1.247 1.147H7.214a.5.5 0 0 1-.347-.86zM20 26a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHighlighter32);
